import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { TreeModule } from 'primeng/tree';

import { AuthService } from '@application/auth/auth.service';
import { MenuService } from '@application/menu/menu.service';
import { Menu } from '@domain/menu/menu';
import { MenuTreeComponent } from 'presentation/shared/components/menu/components/menu-item/menu-tree.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: true,
  imports: [CommonModule, TreeModule, MenuTreeComponent]
})
export class MenuComponent implements OnInit {
  @ViewChild('menu', { static: false }) menu: any;
  items!: Menu[] | null;
  selected: any;
  subscription: Subscription[] = [];
  menuService = inject(MenuService);
  authService = inject(AuthService);
  display = this.menuService.getDisplay();
  usuario = this.authService.usuario;
  logoPath = '';

  constructor() {}

  ngOnInit() {
    this.menuService.open();
    const usuario = this.authService.usuario();
    if (usuario) {
      this.items = usuario.menu;
      const { produtosEGTEC } = usuario;
      this.logoPath = `/assets/img/logos/logo-${[produtosEGTEC[0]?.nome?.toLowerCase()]}.png`;
      // const subscription = this.menuService.listenStorageChanges();
      // this.listenDisplayMenu();
      // this.listenMenuItems();
      //
      // this.subscription.push(subscription);
    }
  }

  /*  listenDisplayMenu() {
        const subscription = this.menuService
          .getDisplayMenuObservable()
          .subscribe((display: boolean) => {
            this.display = display;
          });
  
        this.subscription.push(subscription);
      }
  
      listenMenuItems() {
        const subscription = this.menuService
          .getItemsObservable()
          .subscribe(menuItems => {
            this.items = menuItems;
          });
  
        this.subscription.push(subscription);
      }
  
      toggleMenu = () => this.menuService[this.display ? 'close' : 'open']();
  
      ngOnDestroy() {
        this.subscription.forEach(subs => subs.unsubscribe());
      }*/
}
